import { Component, OnInit, ViewChild } from '@angular/core';
import { forkJoin, of } from 'rxjs';
import { Alert, AlertService } from '@michelin/theme';
import { DistributorFormComponent } from 'src/app/pages/distributor/components/distributor-form/distributor-form.component';
import { ProductLineDto } from 'src/app/shared/models/product-line/product-line-dto';
import { StateDto } from 'src/app/shared/models/location/state-dto';
import { ProductLineService } from 'src/app/shared/services/product-line/product-line.service';
import { LocationService } from 'src/app/shared/services/location/location.service';
import { UserDto } from 'src/app/shared/models/user/user-dto';
import { UserService } from 'src/app/shared/services/user/user.service';
import { DistributorService } from 'src/app/shared/services/distributor/distributor.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-create-distributor',
    templateUrl: './create-distributor.component.html',
    standalone: false
})
export class CreateDistributorComponent implements OnInit {
  loading: boolean = false;

  data = {
    users: [] as UserDto[],
    productLines: [] as ProductLineDto[],
    states: [] as StateDto[]
  };

  @ViewChild(DistributorFormComponent) distributorForm: DistributorFormComponent;

  constructor(
    private readonly distributorService: DistributorService,
    private readonly userService: UserService,
    private readonly productLineService: ProductLineService,
    private readonly locationService: LocationService,
    private readonly alertService: AlertService,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.loading = true;

    forkJoin({
      users: this.userService.findAll(),
      productLines: this.productLineService.findAll(),
      states: this.locationService.findAllStates()
    })
      .subscribe({
        next: (result) => (this.data = result),
        complete: () => (this.loading = false),
        error: () => this.alertService.showAlert({ content: 'Ocorreu um erro ao carregar as informações', type: 'critical' } as Alert)
      })
      .add(() => (this.loading = false));
  }

  submitForm() {
    this.loading = true;
    this.distributorService
      .create(this.distributorForm.formValues)
      .subscribe({
        next: () =>
          this.router.navigate(['/distributors']).then(() =>
            this.alertService.showAlert({
              type: 'success',
              content: 'Dist. Exclusivo cadastrado com sucesso'
            } as Alert)
          ),
        error: () => {
          this.alertService.showAlert({
            type: 'critical',
            content: 'Ocorreu um erro ao cadastrar o Dist. Exclusivo'
          } as Alert);
        }
      })
      .add(() => (this.loading = false));
  }
}
